import { render, staticRenderFns } from "./ExpandCollapseContent.vue?vue&type=template&id=786568b4&"
import script from "./ExpandCollapseContent.vue?vue&type=script&lang=js&"
export * from "./ExpandCollapseContent.vue?vue&type=script&lang=js&"
import style0 from "./ExpandCollapseContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports